var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_4213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H0V24H24V0ZM12.0004 3L7.07712 5.77499L8.84645 6.74991L12.0004 5.02472L15.0775 6.74991L16.9236 5.77499L12.0004 3ZM15.0768 8.25045L16.8461 9.22537H16.77V11.3257L13.6929 13.0509V16.5013L11.9236 17.5511L10.1542 16.5013V12.976L7.07712 11.2508V9.22537L8.84645 8.25045L12.0004 9.97564L15.0768 8.25045ZM16.8461 12.7506V14.7754L15.0775 15.7503V13.8004L16.8461 12.7506ZM15.0768 17.1759L18.1539 15.4507V12.0004L20 10.8757V16.4257L15.0768 19.2006V17.1759ZM18.1546 8.54998L16.3853 7.50018L18.1546 6.45038L19.9239 7.50018V9.52562L18.1546 10.5754V8.54998ZM10.1542 19.9502V17.9255L11.9236 18.9753L13.6929 17.9255V19.9502L11.9236 21L10.1542 19.9502ZM8.84645 15.7503L7.07712 14.7754V12.6757L8.84645 13.7255V15.7503ZM11.9236 8.54998L10.1542 7.50018L12.0004 6.45038L13.7697 7.50018L11.9236 8.54998ZM7.61545 7.50018L5.76933 8.54998H5.77006V10.5747L4.00074 9.5249V7.50018L5.76933 6.45038L7.61545 7.50018ZM4 10.9506L5.76933 12.0004H5.84613V15.5256L8.92325 17.2508V19.2755L4 16.5005V10.9506Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_4213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/Bnb.77978c77b3e413fbffee13c7975e8cf4.svg";
export { ForwardRef as ReactComponent };